// extracted by mini-css-extract-plugin
module.exports = {"dok-modal":"index__2B7Y7","modal-wrapper":"index__1x34M","min50vh":"index__23Lgm","modal-close-x":"index__TQhI8","modal-tag":"index__152U7","modal-tag-default":"index__1sX40"};